export enum TimeReport_ActivityType {
    MEETINGS        = "meetings",
    LOGGED_TIME     = "logged-time",
    WORKED_ON       = "worked-on",
    PINNED_TASKS    = "pinned-tasks",
    PLANNED_TASKS   = "planned-tasks",
    RECENT_TASKS    = "recent-tasks"
}
